(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestDualRow', {
        templateUrl: '/core-ui/component-views/ap-erx-request-dual-row.html',
        bindings: {
            label: '<?',
            firstValue: '<',
            firstText: '<?',
            secondValue: '<?',
            secondText: '<?',
            warn: '&',
            header: '&',
        },
        controllerAs: 'vm',
        controller: [
            '_',
            ApErxRequestDualRow,
        ],
    });

    function ApErxRequestDualRow(
        _
    ) {
        var vm = this;
        vm.hasWarning = hasWarning;

        function hasWarning() {
            if(_.isNil(vm.firstValue) || _.isNil(vm.secondValue)) {
                return false;
            }

            var result = String.prototype.toUpperCase.call(vm.firstValue) !== String.prototype.toUpperCase.call(vm.secondValue);

            return result;
        }
    }

})(window.angular);
